import { render, staticRenderFns } from "./WriteEmail.vue?vue&type=template&id=86be3b58&scoped=true&"
import script from "./WriteEmail.vue?vue&type=script&lang=js&"
export * from "./WriteEmail.vue?vue&type=script&lang=js&"
import style0 from "./WriteEmail.vue?vue&type=style&index=0&id=86be3b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86be3b58",
  null
  
)

export default component.exports